import { INITIAL_ORDER_PATTERN_FORM } from '~/pages/Simulation/constants/form'
import { OrderPatternSchema } from '~/pages/Simulation/schemas'
import { convertPhysicalContractDeliveryTypeToDeliveryType } from '~/pages/Simulation/utils/deliveryTypeConverter'
import { useGetMe } from '~/pages/hooks/useGetMe'

export function useInitialOrderPatternForm(): OrderPatternSchema {
  const { deliveryType } = useGetMe()

  return {
    ...INITIAL_ORDER_PATTERN_FORM,
    selfDeliveryType:
      convertPhysicalContractDeliveryTypeToDeliveryType(deliveryType),
  }
}
